import React from "react";
import MoneyClass from "../services/money/Money";
var Money = function (_a) {
    var amount = _a.amount, currency = _a.currency, locale = _a.locale, _b = _a.formatOptions, formatOptions = _b === void 0 ? {} : _b;
    return (React.createElement(React.Fragment, null, new MoneyClass(amount, currency).format(locale, formatOptions)));
};
export default Money;
//# sourceMappingURL=Money.js.map